import { manualFetch } from 'src/utils/fetch'
import { useState, useEffect, useCallback } from 'react'
import { getTreasureHunter } from 'src/api/treasurehunter'
import { Spin, Pagination } from 'antd'
import TreasureHunterCard from './treasurehuntercard'
import './SectionTreasureHunter.css'
const SectionTreasureHunter = ({ searchTerm }) => {
  const [treasureHunter, setTreasureHunter] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalItems, setTotalItems] = useState(0)
  const pageSize = 10

  const fetchImage = async (url) => {
    const response = await manualFetch(url, {
      headers: {
        accept: 'image/*',
      },
    })
    const imageBlob = await response.blob()
    return URL.createObjectURL(imageBlob)
  }

  const fetchData = useCallback(async (page, term) => {
    try {
      setDataLoaded(false)
      const data = await getTreasureHunter(page, pageSize, term)
      const survivalZoneData = await Promise.all(
        data.data.map(async (element) => {
          const imageUrl = await fetchImage(element.fullS3Path)
          const thumbnailImageUrl = await fetchImage(element.thumbnailS3Path)
          return {
            ...element,
            imageUrl,
            thumbnailImageUrl,
          }
        })
      )
      setTreasureHunter(survivalZoneData)
      setTotalItems(data.total_items)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setDataLoaded(true)
    }
  }, [])

  useEffect(() => {
    fetchData(currentPage - 1, searchTerm)
  }, [currentPage, searchTerm, fetchData])

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  return (
    <div>
      {dataLoaded ? (
        <div>
          <div className="treasure-hunter-container">
            {treasureHunter.map((treasure) => (
              <TreasureHunterCard
                key={treasure.id}
                id={treasure.id}
                img={treasure.imageUrl}
                name={treasure.name}
                desc={treasure.description}
                instruction={treasure.instruction}
                title={treasure.title}
                descFr={treasure.descriptionFr}
                instructionFr={treasure.instructionFr}
                titleFr={treasure.titleFr}
                descAr={treasure.descriptionAr}
                instructionAr={treasure.instructionAr}
                titleAr={treasure.titleAr}
                enabled={treasure.enabled}
                category={treasure.category}
                accessLevels={treasure.accessLevels}
                thumbnailImage={treasure.thumbnailImageUrl}
                complex={treasure.complex}
                retentionDepth={treasure.retentionDepth}
                monetizationModel={treasure.monetizationModel}
                tier={treasure.tier}
              />
            ))}
          </div>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalItems}
            onChange={handlePageChange}
            showSizeChanger={false}
            style={{ marginTop: 10 }}
          />
        </div>
      ) : (
        <div className="spinner-container">
          <Spin size="large" />
        </div>
      )}
    </div>
  )
}

export default SectionTreasureHunter
